// Forward quantity dropdowns to the theme's existing cart update input.
document.addEventListener('change', event => {
  const select = event.target.closest('.reference-cart-quantity');
  if (!select) return;
  event.stopImmediatePropagation();
  const input = document.getElementById(select.dataset.input);
  if (!input || input.disabled) return;
  input.value = select.value;
  input.dispatchEvent(new Event('change', {bubbles:true}));
}, true);
